/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OAuth2/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import CancelAction from './CancelAction/index'
import ConnectAction from './ConnectAction/index'
import Processing from './Processing/index'
import React from 'react'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderCloseAction from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderCloseAction/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function OAuth2({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/AddAction/OAuth2"
  
}) {
let constantData = 'Connect'
let appNameValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'name',
})
let constantData1 = 'app'
let aggregateData = fromAggregate.join(constantData, appNameValueData, constantData1)
let onClose = fromHelpers.useOnClose({
  children,
  viewPath
  
})
let appConnectingValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'connecting',
})
  return (<React.Fragment
>
<Processing
  viewPath={`${viewPath}/Processing`}
/>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 size="medium"
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<React.Fragment>
<TysiaModalHeaderTitle
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 data="'Connect'"
 data="app.name"
 data="'app'"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
<TysiaModalHeaderCloseAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderCloseAction`}
 onClose={onClose}
/>
</React.Fragment>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 text={appConnectingValueData ? "Complete the login process in the new window we just opened. This dialog will close itself once the connection is done." : "Press the Login button to open a new window and login to the app with your credentials."}
 data="app.connecting"
/>
)}
</TysiaModalContent>
<TysiaModalFooter
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<CancelAction
{...childProps}
  viewPath={`${viewPath}/CancelAction`}
/>
<ConnectAction
{...childProps}
  viewPath={`${viewPath}/ConnectAction`}
/>
</React.Fragment>
)}
</TysiaModalFooter>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}